// import { SiOpenai } from 'react-icons/si';
import { useNavigate } from 'react-router-dom';
import { AI } from '../../constant/imagePath';

function FloatingChatBot() {
  const navigate = useNavigate();

  const handleChatBotClick = () => {
    navigate('/chat-bot');
  };

  const floatingStyle = {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    width: '60px',
    height: '60px',
    backgroundColor: '#00a997',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    zIndex: 99999,
    color: 'white',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
    border: '2px solid white'
  };

  return (
    <div onClick={handleChatBotClick} style={floatingStyle}>
      <img
        src={AI}
        alt="Chat Bot"
        style={{
          width: '60%',
          height: '60%'
        }}
      />
    </div>
  );
}

export default FloatingChatBot;
